import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round' as const
};

export const PowerButtonIcon = createSvgIcon(
  <path
    d="M3.72533 6.40763C2.30462 7.82842 1.33712 9.63858 0.945169 11.6092C0.553223 13.5799 0.754436 15.6225 1.52336 17.4788C2.29229 19.3351 3.5944 20.9217 5.26504 22.0379C6.93567 23.1542 8.89979 23.75 10.909 23.75C12.9183 23.75 14.8824 23.1542 16.553 22.0379C18.2237 20.9217 19.5258 19.3351 20.2947 17.4788C21.0636 15.6225 21.2648 13.5799 20.8729 11.6092C20.481 9.63858 19.5135 7.82842 18.0927 6.40763M10.909 15.0354L10.909 0.75"
    {...strokeProps}
  />,
  { displayName: 'PowerButtonIcon', viewBox: '0 0 22 25' }
);
